import React, { useMemo, useState, useCallback, useEffect } from "react";
import { useTable ,usePagination } from "react-table";
import axiosApi from "../Utils/axiosApi";
import checkPermission from '../Utils/checkPermission';
import Pagination from "@mui/material/Pagination";

import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Alert,
  TextField,
  DialogActions,
  Typography,
  Grid,Checkbox,FormControlLabel,
} from "@mui/material";
//import AddIcon from "@mui/icons-material/Add";
import HeaderMenu from "../Header/HeaderMenu";
import CreateHosteler from "./CreateHosteler";
import "./HostlerList.css";
import AbsenceDialog from "../HostelDetails/AbsenceDialog";
import HostlerAdditionalChargeList from "../HostelDetails/HostlerAdditionalChargeList";

const HostlerList = () => {
   const [selectedHosteler, setSelectedHosteler] = useState("");
  const [pendingHostelFilter, setPendingHostelFilter] = useState("");
  //const [pendingCityFilter, setPendingCityFilter] = useState("");
  const [pendingHostelerFilter, setPendingHostelerFilter] = useState("");
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [hostelList, setHostelList] = useState([]);
  const [hostelerList, setHostelerList] = useState([]);
  //const [cities, setCities] = useState([]);
  const [formData, setFormData] = useState({ cityId: "" });
  const [deleteMessage, setDeleteMessage] = useState("");
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);

  // Absence dialog
  const [absenceDialogOpen, setAbsenceDialogOpen] = useState(false);
  const [absenceFormData, setAbsenceFormData] = useState(null);
  // Additional Charges dialog
const [hostlerAdditionalChargesDialogOpen, setHostlerAdditionalChargesDialogOpen] = useState(false);
const [hostlerAdditionalChargesData, setHostlerAdditionalChargesData] = useState(null);
const [activeOnly, setActiveOnly] = useState(true);
const [errorMessage, setErrorMessage] = useState("");
  // Fetch hostels
  useEffect(() => {
    axiosApi
      .post("/hostel/getHostelName", {})
      .then((response) => {
        const data = Array.isArray(response.data)
          ? response.data
          : response.data.hostels || [];
        setHostelList(data.map(([id, name]) => ({ id, hostelName: name })));
      })
      .catch((error) => console.error("Error fetching hostels:", error));
  }, []);
const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  // Fetch hostelers
  /*useEffect(() => {
    axiosApi
      .post("/hosteler/getHosteler", {})
      .then((response) => {
        const data = Array.isArray(response.data)
          ? response.data
          : response.data.hostelers || [];
        setHostelerList(
          data.map((h) => ({
            ...h,
            hostelerName: h.hostelerName || "",
            hostelName: h.hostelName || "",
            hostelId: h.hostelId,
            id: h.id,
            city: h.city || "",
          }))
        );
      })
      .catch((error) => console.error("Error fetching hostelers:", error));
  }, []);*/

 

  const handleManage = useCallback(async (hosteler) => {
    try {
      const response = await axiosApi.post("/hosteler/getHosteler", {
        hostelerIds: [hosteler.id],
		includeInactiveHostellers:true,
      });
      const details =
        Array.isArray(response.data) && response.data.length > 0
          ? response.data[0]
          : response.data;
      setSelectedHosteler(details);
      setIsUpdate(true);
      setDialogOpen(true);
    } catch (err) {
      console.error("Error fetching hosteler details:", err);
    }
  }, []);

  const handleHostelerAbsents = useCallback(async (hosteler) => {
    try {
      const response = await axiosApi.post(
        "/hostelerLeaveRequest/getHostelLeaveRequest",
        {  
		    hostelerIds: [hosteler.id], 
			hostelIds: [hosteler.hostelId]
		}
		
		
      );
      const absences = Array.isArray(response.data) ? response.data : [];
      setAbsenceFormData({
        hostelerId: hosteler.id,
        hostelId: hosteler.hostelId,
        hostelerName: hosteler.hostelerName || "",
        hostelName: hosteler.hostelName || "",
        absences,
      });
      setAbsenceDialogOpen(true);
    } catch (err) {
      console.error("Error fetching absents:", err);
      setDeleteMessage("Failed to open absence form.");
    }
  }, []);
  
const handleHostlerAdditionalCharges = useCallback(async (hosteler) => {
  try {
    const response = await axiosApi.post(
      "/hostelerAdditionalExpense/getAdditionalExpense",
      { hostelerIds: [hosteler.id] ,hostelIds: [hosteler.hostelId] }
    );
    const hostlerAdditionalCharges = Array.isArray(response.data) ? response.data : [];
    setHostlerAdditionalChargesData({
  hostelerId: hosteler.id,
  hostelId: hosteler.hostelId,
  hostelerName: hosteler.hostelerName || "",
  hostelName: hosteler.hostelName || "",
  expenses: hostlerAdditionalCharges,   // ✅ renamed
});

    setHostlerAdditionalChargesDialogOpen(true);
  } catch (err) {
    console.error("Error fetching additional charges:", err);
    setDeleteMessage("Failed to open additional charges form.");
  }
}, []);
  const confirmDelete = async () => {
    if (!deleteConfirmId) return;
    try {
      await axiosApi.post("/hosteler/deleteHosteler", {
        hostelerIds: [deleteConfirmId],
      });
      setDeleteMessage(
        `Hosteler with ID ${deleteConfirmId} has been deleted.`
      );
      setDeleteConfirmId(null);
      setDeleteDialogOpen(false);
      handleSearch();
    } catch (error) {
      console.error("Error deleting hosteler:", error);
      setDeleteMessage("Failed to delete the hosteler. Please try again.");
    }
  };

  const handleSearch = () => {
	  
	   if (!pendingHostelFilter) {
    setErrorMessage("Please select a hostel.");
    return;
  }

  setErrorMessage("");

  gotoPage(0);
 

  const selectedHostelIds = hostelList
    .filter((h) =>
      pendingHostelFilter ? h.hostelName === pendingHostelFilter : true
    )
    .map((h) => h.id);

  const requestPayload = {
    hostelIds: selectedHostelIds.length > 0 ? selectedHostelIds : null,
    cityId: formData.cityId || null,
    hostelerName: pendingHostelerFilter || null,
	includeInactiveHostellers: !activeOnly,
    sortBy: "hostlerFirstName",
    sortOrder: "ASC",
  };

  // ✅ Include accommodationType ONLY if selected (not "All")
  if (formData.accommodationType) {
    requestPayload.accommodationType = formData.accommodationType;
  }

  axiosApi.post("/hosteler/getHosteler", requestPayload).then((response) => {
    const data = Array.isArray(response.data) ? response.data : [];
    setHostelerList(data);
  });
};



 const handleReset = () => {
  gotoPage(0);
  setPendingHostelFilter("");
  setPendingHostelerFilter("");
  setSelectedHosteler("");
  setFormData({
    cityId: "",
    accommodationType: "",
  });
  setActiveOnly(true);
  setErrorMessage("");
  setHostelerList([]);
};


  const handleCloseDialog = () => {
    setDialogOpen(false);
    setIsUpdate(false);
    setSelectedHosteler("");
  };

  

  const columns = useMemo(
    () => [
      { Header: '#', accessor: '' },
      { Header: "Hostel Name", accessor: "hostelName" },
      { Header: "Hosteler Name", accessor: "hostelerName" },
      { Header: "Mobile Number", accessor: "mobileNumber" },
      { Header: "Parent's Mobile Number", accessor: "guardianContactNumber" },
      { Header: "State", accessor: "stateName" },
      { Header: "City", accessor: "cityName" },
      { Header: "Country", accessor: "countryName" },
{
  Header: "Actions",
  accessor: "actions",
  Cell: ({ row }) => (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",   // keep all buttons in one row
        justifyContent: "flex-start",
        alignItems: "center",
        gap: .5,               // spacing between buttons
        whiteSpace: "nowrap",   // prevent wrapping to new line
      }}
    >
      <Button disabled={!checkPermission("Hostel", "Hosteler List", "VIEW")}
        variant="outlined"
        size="small"
        color="primary"
        onClick={() => handleManage(row.original)}
      >
        Manage
      </Button>
      <Button disabled={!checkPermission("Hostel", "Hosteler List", "VIEWABSENT")}
        variant="outlined"
        size="small"
        color="warning"
        onClick={() => handleHostelerAbsents(row.original)}
      >
        Absent
      </Button>
      <Button disabled={!checkPermission("Hostel", "Hosteler List", "VIEWADDEXP")}
        variant="outlined"
		title="Extra Charges"
        size="small"
        color="secondary"
        onClick={() => handleHostlerAdditionalCharges(row.original)}
      >
       Extra
      </Button>
      <Button disabled={!checkPermission("Hostel", "Hosteler List", "DELETE")}
        variant="outlined"
        size="small"
        color="error"
        onClick={() => {
          setDeleteConfirmId(row.original.id);
          setDeleteDialogOpen(true);
        }}
      >
        Delete
      </Button>
    </Box>
  ),
}


    ],
    [handleManage, handleHostelerAbsents,handleHostlerAdditionalCharges]
  );

  const {
  getTableProps,
  getTableBodyProps,
  headerGroups,
  page,               // 🔥 paginated rows
  prepareRow,
  gotoPage,
  pageCount,
  state: { pageIndex, pageSize },
  setPageSize,
} = useTable(
  {
    columns,
    data: hostelerList,
    initialState: { pageIndex: 0, pageSize: 5 },
  },
  usePagination
);


  return (
    <div>
      {!isDialogOpen && <HeaderMenu />}

      {deleteMessage && (
        <Alert severity="success" onClose={() => setDeleteMessage("")}>
          {deleteMessage}
        </Alert>
      )}

{errorMessage && (
  <Alert
    severity="error"
    sx={{ mb: 2 }}
    onClose={() => setErrorMessage("")}
  >
    {errorMessage}
  </Alert>
)}
      {/* Filters */}
     <Box
  sx={{
    backgroundColor: "#f9f9f9",
    p: 2,
    borderRadius: 2,
    mb: 3,
    boxShadow: 1,
  }}
>
  <Grid container alignItems="center" spacing={2} wrap="wrap">
    {/* Hostel dropdown */}
    <Grid item>
      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel>Hostel Name</InputLabel>
        <Select
          value={pendingHostelFilter}
          onChange={(e) => setPendingHostelFilter(e.target.value)}
          label="Hostel Name"
        >
          <MenuItem value="">All</MenuItem>
          {hostelList.map((hostel) => (
            <MenuItem key={hostel.id} value={hostel.hostelName}>
              {hostel.hostelName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

    

    {/* Hosteler Name input */}
    <Grid item>
      <TextField
        label="Hosteler Name"
        size="small"
        value={pendingHostelerFilter}
        onChange={(e) => setPendingHostelerFilter(e.target.value)}
        sx={{ minWidth: 200 }}
      />
    </Grid>
	<Grid item>
  <FormControl size="small" sx={{ minWidth: 200 }}>
    <InputLabel>Accommodation Type</InputLabel>
    <Select
      name="accommodationType"
      value={formData.accommodationType || ""}
      onChange={handleInputChange}
      label="Accommodation Type"
    >
      <MenuItem value="">All</MenuItem>
      <MenuItem value="STAY_ONLY">Stay Only</MenuItem>
      <MenuItem value="STAY_WITH_FOOD">Stay With Food</MenuItem>
      <MenuItem value="FOOD_ONLY">Food Only</MenuItem>
    </Select>
  </FormControl>
</Grid>
<Grid item>
  <FormControlLabel
    control={
      <Checkbox
        checked={activeOnly}
        onChange={(e) => setActiveOnly(e.target.checked)}
      />
    }
    label="Active Hostelers Only"
  />
</Grid>
    {/* Buttons right after filters */}
    <Grid item>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button variant="contained" size="small" onClick={handleSearch}>
          Search
        </Button>
        <Button
          variant="outlined"
          size="small"
          color="secondary"
          onClick={handleReset}
        >
          Reset
        </Button>
      </Box>
    </Grid>
  </Grid>
</Box>



      {/* Table */}
      <div className="hostler-list-container">
    {/* Heading Row with Label */}
<Box
  sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    mb: 3,
  }}
>
  {/* Hostler List Label */}
  <Typography
    variant="h5"
    sx={{
      fontWeight: 600,
      mb: 0, // spacing below label
    }}
  >
    Hostler List
  </Typography>

  {/* Centered Create Hosteler Button */}
  <Button disabled={!checkPermission("Hostel", "Hosteler List", "CREATE")}
    variant="contained"
    color="primary"
    size="small"
    onClick={() => {
      setSelectedHosteler("");
      setIsUpdate(false);
      setDialogOpen(true);
    }}
    sx={{
      textTransform: "none",
      minWidth: 120,
      maxWidth: 180,
    }}
  >
    Create Hosteler
  </Button>
</Box>

        <div className="table-container">
          <table {...getTableProps()} className="table">
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()} key={column.id}>
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.length === 0 ? (
                <tr>
                  <td colSpan={columns.length} style={{ textAlign: "center" }}>
                    No records found.
                  </td>
                </tr>
              ) : (
                page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()} key={row.id}>
                      {row.cells.map((cell) => (
  <td
    {...cell.getCellProps()}
    key={cell.column.id}
    data-label={cell.column.Header}  // 👈 Add this line
  >
    {cell.render("Cell") || "N/A"}
  </td>
))}

                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
		  {hostelerList.length > 0 && (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      mt: 2,
    }}
  >
    <Pagination
      count={pageCount}
      page={pageIndex + 1}
      onChange={(e, value) => gotoPage(value - 1)}
      color="primary"
      shape="rounded"
    />

    <Box>
      <label style={{ marginRight: 8 }}>Rows per page:</label>
      <select
        value={pageSize}
        onChange={(e) => setPageSize(Number(e.target.value))}
      >
        {[5, 10, 15, 20].map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
    </Box>
  </Box>
)}

        </div>

        {/* Create/Edit Dialog */}
       <Dialog
  open={isDialogOpen}
  onClose={(event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return; // 🚫 Prevent closing on outside click or ESC
    }
    handleCloseDialog();
  }}
  disableEscapeKeyDown
  fullWidth
  maxWidth="sm"
>
  <DialogTitle>
    {selectedHosteler ? "Edit Hosteler" : "Create Hosteler"}
  </DialogTitle>
  <DialogContent>
    <CreateHosteler
      isDialog={true}
      isUpdate={isUpdate}
      hosteler={selectedHosteler}
      onClose={handleCloseDialog}
    />
  </DialogContent>
</Dialog>


        {/* Absence Form Dialog */}
        <AbsenceDialog
          open={absenceDialogOpen}
          onClose={() => setAbsenceDialogOpen(false)}
          absences={absenceFormData?.absences || []}
          hostelId={absenceFormData?.hostelId}
          hostelName={absenceFormData?.hostelName}
          hostelerId={absenceFormData?.hostelerId}
          hostelerName={absenceFormData?.hostelerName}
        />
{/* HostlerAdditionalCharges */}
        <HostlerAdditionalChargeList
  open={hostlerAdditionalChargesDialogOpen}
  onClose={() => setHostlerAdditionalChargesDialogOpen(false)}
  expenses={hostlerAdditionalChargesData?.expenses || []}   // ✅ now matches component
  hostelId={hostlerAdditionalChargesData?.hostelId}
  hostelName={hostlerAdditionalChargesData?.hostelName}
  hostelerId={hostlerAdditionalChargesData?.hostelerId}
  hostelerName={hostlerAdditionalChargesData?.hostelerName}
/>

        {/* Delete Confirmation Dialog */}
        {isDeleteDialogOpen && (
          <Dialog
            open={isDeleteDialogOpen}
            onClose={() => setDeleteDialogOpen(false)}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent>
              <p>Are you sure you want to delete this hosteler?</p>
            </DialogContent>
            <DialogActions>
              <Button variant="contained" color="error" onClick={confirmDelete}>
                Yes, Delete
              </Button>
              <Button
                variant="outlined"
                onClick={() => setDeleteDialogOpen(false)}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </div>
    </div>
  );
};

export default HostlerList;